import { useIsOnTrial } from 'features/pricing/hook/useIsOnTrial';
import { useCallback } from 'react';
import { shallowEqual } from 'react-redux';
import { pushToHubSpotQueue } from 'services/tracking/pushToHubSpotQueue';
import { TrackingEventUserDataAttributes } from 'services/tracking/types';
import { useAppSelector } from 'store/hooks';

export const useSendHubSpotIdentify = () => {
  const customer = useAppSelector(state => state.customer, shallowEqual);
  const customerTeam = customer.teams && customer.teams.length > 0 ? customer.teams[0] : null;
  const { isOnTrial } = useIsOnTrial();

  return useCallback(
    (trackingData: TrackingEventUserDataAttributes) => {
      // https://developers.hubspot.com/docs/reference/api/analytics-and-events/tracking-code#identifying-contacts
      pushToHubSpotQueue('identify', {
        email: trackingData.email,
        backend_user_id: trackingData.userId,
        subscription_plan: trackingData.pricingPlanName,
        subscription_status: trackingData.subscriptionStatus,
        verified: trackingData.isVerified,
        is_on_trial: isOnTrial,
        team_id: customerTeam?.id,
        team_name: customerTeam?.name,
        team_role: customer.teamRole,
      });

      // Quote from HubSpot docs:
      // This function call stores the data in the tracker,
      // but the data is not actually passed to HubSpot with this call.
      // The data will only be passed when tracking a page view or an event
      // (with either the trackPageView or trackEvent functions).
      pushToHubSpotQueue('trackPageView');
    },
    [customer.teamRole, customerTeam?.id, customerTeam?.name, isOnTrial]
  );
};

export const trackHubSpotPathChange = (pathname: string) => {
  pushToHubSpotQueue('setPath', pathname);
  pushToHubSpotQueue('trackPageView');
};
